import {Box, CircularProgress} from "@mui/material";
import React from "react";

const CustomLoader = ({size, color = 'primary'}) => {
    return (
        <Box display={'flex'} justifyContent={'center'}>
            <CircularProgress size={size} color={color}/>
        </Box>
    )
}

export default CustomLoader